var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipleChoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 7,
    height: 7,
    rx: 1.5,
    fill: "#442B8C",
    stroke: "#442B8C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 10.95,
    width: 6.92014,
    height: 7,
    rx: 1.5,
    stroke: "#442B8C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9502,
    y: 0.5,
    width: 6.92014,
    height: 7,
    rx: 1.5,
    stroke: "#442B8C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9502,
    y: 10.95,
    width: 6.92014,
    height: 7,
    rx: 1.5,
    stroke: "#442B8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleChoice);
export default __webpack_public_path__ + "static/media/multiple-choice.e5a1c13fab7e8f7e27dc0f165c653f90.svg";
export { ForwardRef as ReactComponent };